import { useEffect } from 'react'
import PropTypes from 'prop-types'

const ScrollTop = ({ location, children }) => {
  const { pathname, search } = location

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname, search])

  return children
}

ScrollTop.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string,
    search: PropTypes.string,
  }),
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
}

export default ScrollTop
